<template>
  <div class="row">
    <div class="col-md-12">
      <div class="text-center">
        <div class="custom-control custom-radio custom-control-inline">
          <input
            v-model="spent_or_gain"
            type="radio"
            id="CREDITO"
            name="spent_or_gain"
            value="CREDITO"
            class="custom-control-input"
            @change="handleChangeSpentOrGain($event.target.value)"
          />
          <label class="custom-control-label" for="CREDITO">CRÉDITO</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input
            v-model="spent_or_gain"
            type="radio"
            id="DEBITO"
            name="spent_or_gain"
            value="DEBITO"
            class="custom-control-input"
            @change="handleChangeSpentOrGain($event.target.value)"
          />
          <label class="custom-control-label" for="DEBITO">DÉBITO</label>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <label>Vence em</label>
      <input type="date" class="form-control" v-model="due_date" />
    </div>
    <div class="col-md-4">
      <label>Realizado em</label>
      <input type="date" class="form-control" v-model="paid_in_date" />
    </div>
    <div class="col-md-4">
      <label>Competência</label>
      <input type="date" class="form-control" v-model="competence" />
    </div>
    <div class="col-md-4">
      <input
        type="text"
        placeholder="Descrição"
        class="form-control"
        v-model="description"
      />
    </div>
    <div class="col-md-4">
      <input
        type="text"
        placeholder="Valor"
        class="form-control"
        v-model="value"
        @input="handleInputValue($event.target.value)"
      />
    </div>
    <div class="col-md-4">
      <vs-select
        autocomplete
        class="col-md-12 p-0"
        v-model="finance_configuration_account_id"
      >
        <vs-select-item value="" text="Conta..." />
        <vs-select-item
          v-for="item in finance_configuration_account"
          :key="item.id"
          :value="item.id"
          :text="item.account_nickname"
        />
      </vs-select>
    </div>
    <div class="col-md-4">
      <treeselect
        :options="finance_configuration_category"
        placeholder="CATEGORIA..."
        v-model="finance_configuration_category_id"
        noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
      />
    </div>
    <div class="col-md-4" v-if="spent_or_gain == 'CREDITO'">
      <vs-select autocomplete class="col-md-12 p-0" v-model="finance_client_id">
        <vs-select-item value="" text="Cliente..." />
        <vs-select-item
          v-for="item in finance_client"
          :key="item.id"
          :value="item.id"
          :text="item.name"
        />
      </vs-select>
    </div>
    <div class="col-md-4" v-if="spent_or_gain == 'DEBITO'">
      <vs-select autocomplete class="col-md-12 p-0" v-model="provider_id">
        <vs-select-item value="" text="Fornecedor..." />
        <vs-select-item
          v-for="item in providers"
          :key="item.id"
          :value="item.id"
          :text="item.company_name"
        />
      </vs-select>
    </div>
    <div class="col-md-4">
      <vs-select
        autocomplete
        class="col-md-12 p-0"
        v-model="finance_configuration_payment_methods_id"
      >
        <vs-select-item value="" text="Forma de pagamento..." />
        <vs-select-item
          v-for="item in finance_configuration_payment_methods"
          :key="item.id"
          :value="item.id"
          :text="item.description"
        />
      </vs-select>
    </div>
    <div class="col-md-4">
      <vs-select
        autocomplete
        class="col-md-12 p-0"
        v-model="finance_configuration_profit_cost_center_id"
      >
        <vs-select-item value="" text="Centro de custo/lucro..." />
        <vs-select-item
          v-for="item in finance_configuration_profit_cost_center"
          :key="item.id"
          :value="item.id"
          :text="item.description"
        />
      </vs-select>
    </div>
    <div class="col-md-4">
      <vs-select
        autocomplete
        class="col-md-12 p-0"
        v-model="finance_configuration_document_types_id"
      >
        <vs-select-item value="" text="Tipo de documento..." />
        <vs-select-item
          v-for="item in finance_configuration_document_types"
          :key="item.id"
          :value="item.id"
          :text="item.description"
        />
      </vs-select>
    </div>
    <div class="col-md-4">
      <input
        type="text"
        placeholder="Número do documento"
        class="form-control"
        v-model="document_number"
      />
    </div>
    <div class="col-md-4">
      <select v-model="cost_type" class="form-control">
        <option value="">Tipo de custo...</option>
        <option
          v-for="item in cost_types"
          :value="item.value"
          :key="item.value"
        >
          {{ item.description }}
        </option>
      </select>
    </div>
    <div class="col-md-4">
      <select v-model="cost_appropriation" class="form-control">
        <option value="">Apropriação de custo...</option>
        <option
          v-for="item in cost_appropriations"
          :value="item.value"
          :key="item.value"
        >
          {{ item.description }}
        </option>
      </select>
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-12">
      <vs-select
        class="
          col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
          pt-0
          pb-0
          pl-0
          pr-0
        "
        placeholder="Tags..."
        multiple
        autocomplete
        v-model="finance_configuration_tag_ids"
      >
        <vs-select-item
          v-for="item in finance_configuration_tag"
          :key="item.id"
          :text="item.description"
          :value="item.id"
        />
      </vs-select>
    </div>
    <div class="col-md-12">
      <ChromeSpeechToTextTextarea
        placeholder="Observação..."
        rows="3"
        v-model="note"
      />
    </div>
    <div class="col-md-12 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-6 pt-0 pb-0">
      <v-btn :disabled="loading" class="btn-cancel" @click="$emit('cancel')"
        >CANCELAR</v-btn
      >
    </div>
    <div class="col-md-6 pt-0 pb-0 text-right">
      <ConfirmationDialog
        :disabled="loading"
        :loading="loading"
        headerClass="modal-header-i"
        message-title="EDITAR?"
        :message-body="`Deseja realmente editar o(s) lançamento(s) selecionado(s)?`"
        open-class="btn-save"
        open-left-icon="fas fa-save"
        openText="SALVAR"
        @yes="handleEdit"
      />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages";

import ConfirmationDialog from "../../../../Components/ConfirmationDialog";

import ChromeSpeechToTextTextarea from "../../../../Components/ChromeSpeechToTextTextarea";

import Treeselect from "@riophae/vue-treeselect";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";

import {
  formatMoney,
  formatValueNegativeOnKeyUp,
  formatValueOnKeyUp,
} from "../../../../../lib/format";

import moment from "moment";

export default {
  name: "EditMultiples",
  components: {
    ErrorsMessages,
    ConfirmationDialog,
    ChromeSpeechToTextTextarea,
    Treeselect,
  },
  props: {
    itemsSelected: Array,
    finance_configuration_account: Array,
    providers: Array,
    finance_client: Array,
    finance_configuration_document_types: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
  },
  data() {
    return {
      spent_or_gain: "CREDITO",
      due_date: "",
      paid_in_date: "",
      competence: "",
      description: "",
      value: "0,00",
      finance_configuration_account_id: "",
      finance_configuration_category_id: "",
      finance_client_id: "",
      provider_id: "",
      finance_configuration_payment_methods_id: "",
      finance_configuration_profit_cost_center_id: "",
      finance_configuration_document_types_id: "",
      document_number: "",
      cost_type: "",
      cost_appropriation: "",
      finance_configuration_tag_ids: [],
      note: "",
      errors: [],
      loading: false,
    };
  },

  created() {
    this.finance_configuration_category_id = null;
  },

  methods: {
    moment,
    formatMoney,
    handleChangeSpentOrGain(type) {
      if (type == "CREDITO") {
        this.value = formatValueOnKeyUp(String(this.value).replace("-", ""));
      } else {
        this.value = formatValueNegativeOnKeyUp(this.value);
      }
    },
    handleInputValue(value) {
      if (this.spent_or_gain == "CREDITO") {
        this.value = formatValueOnKeyUp(value);
      } else {
        this.value = formatValueNegativeOnKeyUp(value);
      }
    },
    async handleEdit() {
      try {
        this.loading = true;

        const {
          itemsSelected,
          spent_or_gain,
          due_date,
          paid_in_date,
          competence,
          description,
          value,
          finance_configuration_account_id,
          finance_configuration_category_id,
          finance_client_id,
          provider_id,
          finance_configuration_payment_methods_id,
          finance_configuration_profit_cost_center_id,
          finance_configuration_document_types_id,
          document_number,
          cost_type,
          cost_appropriation,
          finance_configuration_tag_ids,
          note,
        } = this;

        let ids = itemsSelected.map(({ id }) => id);

        let params = {
          itemsSelected: ids,
          spent_or_gain,
          due_date,
          paid_in_date,
          competence,
          description,
          value,
          finance_configuration_account_id,
          finance_configuration_category_id,
          finance_client_id,
          provider_id,
          finance_configuration_payment_methods_id,
          finance_configuration_profit_cost_center_id,
          finance_configuration_document_types_id,
          document_number,
          cost_type,
          cost_appropriation,
          finance_configuration_tag_ids,
          note,
        };

        const response = await api.put(
          "/rest-home/financial/launch/finance-launch-bills-to-pay-installments/edit",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>